import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "uk-modal-dialog uk-modal-body" }
const _hoisted_3 = { class: "uk-modal-title" }
const _hoisted_4 = { class: "input-wrapper uk-margin-small" }
const _hoisted_5 = { class: "uk-form-label" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "uk-modal-close-outside",
  type: "button",
  "uk-close": ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_drop_area = _resolveComponent("drop-area")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.modalId,
    "uk-modal": "",
    class: "basic-modal",
    onHidden: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenModalHandler && _ctx.hiddenModalHandler(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('images.upload.heading')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, " *" + _toDisplayString(_ctx.$t('images.upload.title.label')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
          class: "uk-input uk-form-small",
          type: "text",
          placeholder: _ctx.$t('images.upload.title.placeholder'),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.title.$touch && _ctx.v$.title.$touch(...args)))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.title]
        ]),
        _createVNode(_component_error_message, {
          errors: _ctx.v$.title.$errors
        }, null, 8, ["errors"])
      ]),
      (_ctx.title)
        ? (_openBlock(), _createBlock(_component_drop_area, {
            key: 0,
            title: _ctx.title,
            onFilesUploaded: _ctx.filesUploadedHandler
          }, null, 8, ["title", "onFilesUploaded"]))
        : _createCommentVNode("", true),
      _hoisted_7
    ])
  ], 40, _hoisted_1))
}